import React, { useState } from "react";

// CoinGlass 공개 임베드 URL
const HEATMAP_URLS = {
  HYPE: "https://www.coinglass.com/pro/futures/LiquidationHeatMap?symbol=HYPEUSDT&exchange=Hyperliquid",
  BTC:  "https://www.coinglass.com/pro/futures/LiquidationHeatMap?symbol=BTCUSDT&exchange=Binance",
  SOL:  "https://www.coinglass.com/pro/futures/LiquidationHeatMap?symbol=SOLUSDT&exchange=Binance",
  ETH:  "https://www.coinglass.com/pro/futures/LiquidationHeatMap?symbol=ETHUSDT&exchange=Binance",
};

const COIN_COLORS = {
  HYPE: "#06b6d4",
  BTC:  "#f59e0b",
  SOL:  "#22c55e",
  ETH:  "#6366f1",
};

export default function HeatmapEmbed({ defaultCoin = "HYPE" }) {
  const [selected, setSelected] = useState(defaultCoin);

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
      {/* 코인 탭 */}
      <div style={{ display:"flex", gap:6 }}>
        {Object.keys(HEATMAP_URLS).map(coin => (
          <button
            key={coin}
            onClick={() => setSelected(coin)}
            style={{
              padding:"5px 14px", borderRadius:8, cursor:"pointer",
              fontSize:13, fontWeight:selected===coin?700:500,
              background: selected===coin ? `${COIN_COLORS[coin]}20` : "#181c24",
              border: selected===coin
                ? `1.5px solid ${COIN_COLORS[coin]}`
                : "1px solid #1e2433",
              color: selected===coin ? COIN_COLORS[coin] : "#6b7280",
              transition:"all .15s",
            }}
          >
            {coin}
          </button>
        ))}
      </div>

      {/* 안내 메시지 */}
      <div style={{
        padding:"8px 12px", borderRadius:8,
        background:"rgba(6,182,212,.06)", border:"1px solid rgba(6,182,212,.2)",
        fontSize:12, color:"#67e8f9",
      }}>
        💡 아래는 CoinGlass 실시간 청산 히트맵이야.
        밝은 노랑/주황 = 청산 밀집 구간 (지지/저항).
        <a href={HEATMAP_URLS[selected]} target="_blank" rel="noopener noreferrer"
          style={{ color:"#06b6d4", marginLeft:8 }}>
          CoinGlass에서 크게 보기 →
        </a>
      </div>

      {/* iframe 임베드 */}
      <div style={{
        borderRadius:10, overflow:"hidden",
        border:"1px solid #1e2433",
        background:"#0a0c10",
        height: 480,
      }}>
        <iframe
          key={selected}
          src={HEATMAP_URLS[selected]}
          width="100%"
          height="480"
          frameBorder="0"
          title={`${selected} Liquidation Heatmap`}
          style={{ display:"block", border:"none" }}
          sandbox="allow-scripts allow-same-origin allow-popups"
        />
      </div>

      <p style={{ fontSize:11, color:"#374151", textAlign:"right" }}>
        데이터 제공: CoinGlass
      </p>
    </div>
  );
}
